<template>
  <pt-adult-sell-order-form class="pt-adult-sell-order-form__page"></pt-adult-sell-order-form>
</template>

<script>
import PtAdultSellOrderForm from 'cps/adult-sell-order/pt-adult-sell-order/pt-adult-sell-order-form/withData'
export default {
  name: 'pt-adult-sell-order-form__view',
  components: {
    'pt-adult-sell-order-form': PtAdultSellOrderForm
  }
}
</script>
